<template>
  <section class="section">
    <div class="container">
      <div class="flex flex-wrap -mx-4">
        <div class="w-full lg:w-5/6 lg:ml-[8.333333%] px-4">
          <div class="text-center mb-7">
            <h3>Habe ich nicht über das Versorgungswerk Anspruch auf eine Berufsunfähigkeitsrente?</h3>
          </div>

          <div class="text-center mb-5">
            <p>
              Sie arbeiten in einem sogenannten freien Beruf und Ihre
              Versorgung wird von einem eigenständigen Versorgungswerk
              geregelt. Die zahlreichen Versorgungswerke bieten im Fall
              der Berufsunfähigkeit im Gegensatz zur gesetzlichen
              Rentenversicherung zudem Versicherungsschutz. Zudem gibt es
              weitere Vorteile:
            </p>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap -mx-4 justify-center">
        <div class="w-full md:w-5/6 lg:w-2/3 px-4">
          <BulletPointList :items="versorgungswerkAdvantages" />
        </div>

        <p class="text-center mb-5 px-2.5">
          Allerdings hat die Berufsunfähigkeitsversicherung der Versorgungswerke auch einen entscheidenden Nachteil:
        </p>

        <div class="w-full md:w-5/6 lg:w-2/3 px-4">
          <BulletPointList
            :items="versorgungswerkDisadvantages"
          />
        </div>
      </div>

      <div class="flex flex-wrap -mx-4 mt-14">
        <div class="w-full lg:w-5/6 lg:ml-[8.333333%] px-4">
          <div class="text-center mb-2.5">
            <h3>Auszug aus dem Versorgungswerk der Steuerberater in Hessen:</h3>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap -mx-4 justify-center">
        <div class="w-5/6 px-4">
          <div class="flex flex-wrap -mx-4 items-center">
            <div class="w-1/4 md:w-1/6 lg:w-1/12 px-4 flex justify-center">
              <SvgVue icon="bedarfsinfo/berufsunfaehigkeit/paragraph.svg" />
            </div>
            <div class="w-3/4 md:w-5/6 lg:w-11/12 px-4 flex flex-col justify-around">
              <p class="mt-7 mb-5">
                “Das Versorgungswerk gewährt seinen Mitgliedern Berufsunfähigkeitsrente,
                wenn diese wegen gesundheitlicher Beeinträchtigung auf Dauer oder auf Zeit nicht mehr in der Lage sind,
                jedwede Tätigkeit, die zur Mitgliedschaft in der jeweiligen berufsständigen Kammer befähigt, auszuüben.
                Anspruchsvoraussetzung ist schließlich die vollständige Einstellung der beruflichen Tätigkeit,
                nachgewiesen durch Rückgabe der Bestellung als Steuerberater.“
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap -mx-4 justify-center mt-14">
        <div class="w-full md:w-5/6 lg:w-1/2 px-4">
          <NiceToKnow :bullets="niceToKnow" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import BulletPointList from '@/bedarf/components/BulletPointList.vue';
import NiceToKnow from '@/bedarf/components/NiceToKnow.vue';
import type { BulletPointItem } from '@/bedarf/components/types';
import SvgVue from "@/application/components/SvgVue";

const versorgungswerkAdvantages: BulletPointItem[] = [
  { icon: 'plus', text: 'Keine Gesundheitsprüfung' },
  {
    icon: 'plus', text: `
    Viele Versorgungswerke verzichten auf eine Wartezeit. In der gesetzlichen
    Rentenversicherung besteht eine Wartezeit von 60 Monaten, bevor Sie
    Anspruch auf die Erwerbsminderungsrente hätten.`
  },
];

const versorgungswerkDisadvantages: BulletPointItem[] = [
  {
    icon: 'minus', text: `
    Ein Anspruch auf Berufsunfähigkeitsrente entsteht ausschließlich bei
    vollständiger Berufsunfähigkeit. Eine vollständige Berufsunfähigkeit
    setzt im Regelfall die Rückgabe der Zulassung beziehungsweise der
    Approbation oder Einstellung der Tätigkeit voraus.`
  },
];

const niceToKnow = [
  {
    title: 'Info:', text: `
    Eine private Berufsunfähigkeitsversicherung zusätzlich zur
    Berufsunfähigkeitsversicherung des Versorgungswerks wird dringend
    empfohlen.`
  },
];
</script>
